export default {
  heading: {
    widgetName: "category",
    widgetID: "107",
    cardCount: "5",
    layoutName: "lob_widget",
    headline: "SHOP DUTY FREE NOW",
    subHeadline: "",
    showMoreURL: "",
    gtmParameters: {
      event: "trackEventNoEcommerce",
      eventActionClick: "click",
      eventActionView: "view",
      eventCategory: `certifiedsuper | Discover Certified Super Food outlets`,
      eventLabelCardClick: `certifiedsuper | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}`,
      eventLabelHeadlineClick: `certifiedsuper | headline | {{headline}}`,
      eventLabelView: `certifiedsuper | Discover Certified Super Food outlets`,
    },
  },

  data: [
      {
        image: "https://images.contentstack.io/v3/assets/blt5baee87c838aa782/blt427e8cf97cbd321b/63edb78181222312420a3240/SEO-landing-pages-Skincare-400x400.jpg",
        title: "Skincare",
        url: "https://www.airasia.com/shop/id/id/category/skincare",
        newTab: "TRUE"
      },
      {
         image: "https://images.contentstack.io/v3/assets/blt5baee87c838aa782/blt92372bdf20b75314/63edb7810185c11a442d676e/SEO-landing-pages-Fragrance-400x400.jpg",
         title: "Parfum",
         url: "https://www.airasia.com/shop/id/id/category/fragrance",
          newTab: "TRUE"
      },
      {
         image: "https://images.contentstack.io/v3/assets/blt3ada34ac485961fd/blt3372e0f482eb7801/63610715b31f265153d6ffb7/lenka-supernova-eyeshadow-seriespng_1667303188423.png",
         title: "Makeup",
         url: "https://www.airasia.com/shop/id/id/category/make-up",
          newTab: "TRUE"
      },
      {
         image: "https://images.contentstack.io/v3/assets/blt3ada34ac485961fd/bltcc818fee40179483/63e08094ee61681a344eec4f/pdpeverfitnovsachetjpeg_1675657362996.jpeg",
         title: "Makanan",
         url: "https://www.airasia.com/shop/id/id/category/food",
          newTab: "TRUE"
      },
      {
         image: "https://images.contentstack.io/v3/assets/blt3ada34ac485961fd/blt3bcecda90f032acd/62ea0837f0a85f14f1b26fdd/earjpg_1659504694954.jpg",
         title: "Elektronik",
         url: "https://www.airasia.com/shop/id/id/category/electronics",
          newTab: "TRUE"
      },
      {
         image: "https://images.contentstack.io/v3/assets/blt3ada34ac485961fd/blt5028f81d38416c1c/6316e038a71bd0396c00bb16/katewoodproductwatchesmonacopng_1662443575155.png",
         title: "Fashion",
         url: "https://www.airasia.com/shop/id/id/category/fashion",
          newTab: "TRUE"
      },
      {
         image: "https://images.contentstack.io/v3/assets/blt3ada34ac485961fd/bltd99029f73b3a01d3/635374fe30af8d0d8050992b/body-wash-mljpg_1666413821673.jpg",
         title: "Travelling",
         url: "https://www.airasia.com/shop/id/id/category/airasia-exclusives",
          newTab: "TRUE"
      },
      {
         image: "https://images.contentstack.io/v3/assets/blt3ada34ac485961fd/blt1f2e525e5ec4561e/62be8ea94914e97d05121428/airasiananoblockminibrickplanewithtowerjpg_1656655528813.jpg",
         title: "Merchandise",
         url: "https://www.airasia.com/shop/id/id/category/airasia-exclusives/merchandise",
          newTab: "TRUE"
      }
    ]
  }
